export enum SideFrameDataEventObject {
  CONVERSATION_QA_REVIEW = 'conversation_qa_review',
  CONVERSATION_QA_REVIEW_FEEDBACK = 'conversation_qa_review_feedback',
  CONVERSATION_QA_REVIEW_EDIT = 'conversation_qa_review_edit',
  CONVERSATION_QA_REVIEW_APPROVAL = 'conversation_qa_review_approval',
  CONVERSATION_QA_CITATION_EXPAND = 'conversation_qa_citation_expand',
  CONVERSATION_QA_CITATION_SOURCE = 'conversation_qa_citation_source',
  CONVERSATION_CSAT_CITATION_EXPAND = 'conversation_csat_citation_expand',
  CONVERSATION_CSAT_CITATION_SOURCE = 'conversation_csat_citation_source',
  SMART_PRODUCTS_UPSELL = 'smart_products_upsell',
}
